import { CrudForm } from '../shared/CrudPage';
import { unitService } from '@kss/api';
import type { Unit, UnitCreate, UnitFilter } from '@kss/api';

type F = { code: string; name: string; precision: number; isActive: boolean };
const empty: F = { code: '', name: '', precision: 0, isActive: true };

export default function NewUnit() {
  return (
    <CrudForm<Unit, UnitCreate, UnitFilter, F>
      title="unit"
      service={unitService}
      idKey="unitId"
      basePath="/panel/units"
      emptyForm={empty}
      fields={[
        { key: 'code', label: 'Code', required: true, placeholder: 'kg' },
        { key: 'name', label: 'Name', required: true, placeholder: 'Kilogram' },
        { key: 'precision', label: 'Decimals allowed', type: 'number', placeholder: '0' },
        { key: 'isActive', label: 'Active', type: 'status' },
      ]}
      fromEntity={(r) => ({
        code: r.code ?? '',
        name: r.name ?? '',
        precision: Number(r.precision ?? 0),
        isActive: !!r.isActive,
      })}
      toEntity={(f, id) => ({
        unitId: id,
        code: f.code,
        name: f.name,
        precision: f.precision || 0,
        isActive: f.isActive,
      })}
      validate={(f) =>
        !f.code.trim() ? 'Code is required' : !f.name.trim() ? 'Name is required' : null
      }
    />
  );
}
